import _extends from "../../../../@babel/runtime/helpers/esm/extends.es.js";
import * as React from "react";
import { gridColumnDefinitionsSelector } from "../../hooks/features/columns/gridColumnsSelector.es.js";
import { useGridSelector } from "../../hooks/utils/useGridSelector.es.js";
import { gridPreferencePanelStateSelector } from "../../hooks/features/preferencesPanel/gridPreferencePanelSelector.es.js";
import { GridPreferencePanelsValue } from "../../hooks/features/preferencesPanel/gridPreferencePanelsValue.es.js";
import { useGridApiContext } from "../../hooks/utils/useGridApiContext.es.js";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.es.js";
import { j as jsxRuntimeExports } from "../../../../react/jsx-runtime.es.js";
const GridPreferencesPanel = /* @__PURE__ */ React.forwardRef(function GridPreferencesPanel2(props, ref) {
  var _preferencePanelState, _rootProps$slotProps, _rootProps$slotProps2;
  const apiRef = useGridApiContext();
  const columns = useGridSelector(apiRef, gridColumnDefinitionsSelector);
  const rootProps = useGridRootProps();
  const preferencePanelState = useGridSelector(apiRef, gridPreferencePanelStateSelector);
  const panelContent = apiRef.current.unstable_applyPipeProcessors("preferencePanel", null, (_preferencePanelState = preferencePanelState.openedPanelValue) != null ? _preferencePanelState : GridPreferencePanelsValue.filters);
  return /* @__PURE__ */ jsxRuntimeExports.jsx(rootProps.slots.panel, _extends({
    ref,
    as: rootProps.slots.basePopper,
    open: columns.length > 0 && preferencePanelState.open,
    id: preferencePanelState.panelId,
    "aria-labelledby": preferencePanelState.labelId
  }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.panel, props, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.basePopper, {
    children: panelContent
  }));
});
export {
  GridPreferencesPanel
};
//# sourceMappingURL=GridPreferencesPanel.es.js.map
